import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import DayPicker, { DateUtils } from "~/components/DayPicker/DayPicker";
import classnames from "classnames";
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  FormattedNumber,
  FormattedDate,
} from "react-intl";
import { DateInfo, ThreeLevelInfo, Loader, BookableErrorMessage } from "~/components";
import { getRateDecimalsNoRounding } from "../../utils/misc";
import { getCalendarKey } from "./util";
import { filter } from "./filterUtils";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actions } from "./reducer";
import {
  dataWithExchangeSelector,
  errorSelector,
  loadingSelector,
  loadedSelector,
  calendarARISelector,
  fullCalendarARILoadingSelector,
  startDateSelector,
  endDateSelector,
  mainAriValueSelector,
  numberOfGuestsSelector,
  numberOfNightsSelector,
  occupantRestrictionSelector,
  mainAriValueWithExchangeSelector,
  inventoryDetailsSelector,
} from "./selectors";
import { createStructuredSelector } from "reselect";
import constants from "../../utils/constants";
import getSymbolFromCurrency from "currency-symbol-map";
import { NightIcon, ExitToAppIcon, CerrarIcon } from "../../theme/assets";
import styles from "./Calendar.scss";
import { withSessionData } from "../../utils/session";
import styled from "styled-components";
import { bookingFormActions } from "../../redux/modules/bookingForm";
import { actions as appActions } from "../../containers/App";
import { fromJS } from "immutable";

const msgs = defineMessages({
  arrival: {
    id: "room_selecton.calendar.arrival",
    description: "arrival",
    defaultMessage: "Arrival",
  },
  departure: {
    id: "room_selecton.calendar.departure",
    description: "departure",
    defaultMessage: "Departure",
  },
  changeDates: {
    id: "room_selecton.calendar.changeDates",
    description: "changeDates",
    defaultMessage: "Change your dates",
  },
  confirmDates: {
    id: "room_selecton.calendar.confirmDates",
    description: "confirmDates",
    defaultMessage: "Confirm Dates",
  },
  night: {
    id: "room_selection.calendar.nights",
    description: "Night",
    defaultMessage: "night",
  },
  errorOcurred: {
    id: "room_selection.calendar.errorOcurred",
    description: "Error Ocurred",
    defaultMessage: "An error occurred",
  },
  total: {
    id: "room_selection.calendar.total",
    description: "Total",
    defaultMessage: "Total",
  },
  disclaimer2: {
    id: "room_selection.calendar.disclaimer2",
    description: "Disclaimer",
    defaultMessage: "Prices are indicative for 2 adults sharing.",
  },
  disclaimer3: {
    id: "room_selection.calendar.disclaimer3",
    description: "Disclaimer",
    defaultMessage: "(*) Not available for 2 adults sharing.",
  },
  discount: {
    id: "room_selection.calendar.discount",
    description: "Discount",
    defaultMessage: "Discount",
  },
  infoDisclaimer: {
    id: "room_selection.calendar.info",
    description: "Info message",
    defaultMessage: "Pick a checkout date",
  },
  person: {
    id: "room_selection.calendar.perPerson",
    description: "per Person",
    defaultMessage: "person",
  },
  nextAvailable: {
    id: "room_selection.calendar.nextAvailable",
    description: "nextAvailable",
    defaultMessage: "Next date available",
  },
  goNextAvailable: {
    id: "room_selection.calendar.goNextAvailable",
    description: "goNextAvailable",
    defaultMessage: "Next date available",
  },
});

const EmptyContainer = styled.div`
  width: 186px;
`;

const Disclaimer = ({ isRangeSet, isPropertyCalendar, isAvailableForOtherOccupations }) => {
  if (isPropertyCalendar) {
    return (
      <div className={styles.disclaimerWrapper}>
        <div
          className={classnames(
            "wbkv9-Calendar-disclaimer",
            styles.disclaimer,
            !isRangeSet && styles.infoDisclaimer
          )}>
          <span
            className={classnames("wbkv9-Calendar-disclaimerMessage", styles.disclaimerMessage)}>
            <div className={styles.inline}>
              <FormattedMessage {...msgs.disclaimer2} />
            </div>
            {isAvailableForOtherOccupations && (
              <div>
                {" "}
                <FormattedMessage {...msgs.disclaimer3} />
              </div>
            )}
          </span>
        </div>
      </div>
    );
  }
  return null;
};

const StayInfo = props => {
  return (
    <div
      className={classnames(
        "wbkv9-Calendar-legendSection",
        styles["Calendar-legendSection"],
        styles[props.mobile ? "Calendar-mobileStayInfo" : "Calendar-stayInfo"]
      )}>
      <div className={styles.datesInfo}>
        <DateInfo
          className={styles.datesInfoElem}
          startDate={props.from}
          endDate={props.to}
          numberOfGuests={props.numberOfGuests}
        />
      </div>
    </div>
  );
};

StayInfo.propTypes = {
  from: PropTypes.object,
  to: PropTypes.object,
  numberOfGuests: PropTypes.number,
  mobile: PropTypes.bool,
};

const RestrictionMessage = ({
  errorMessage,
  status,
  fullyBooked,
  handleFullyBooked,
  nextAvailable,
  className,
  hideCalendar,
}) => {
  if (!errorMessage) {
    return null;
  }
  return (
    <div className={classnames(styles.fullBookedMsg, className)}>
      <div
        className={classnames(
          "wbkv9-Calendar-fullBooked",
          styles["Calendar-fullBooked"],
          styles[`Calendar-fullBooked-${status}`]
        )}>
        <div
          className={classnames("wbkv9-Calendar-fullBookedBox", styles["Calendar-fullBookedBox"])}
        />
        <div
          className={classnames(
            "wbkv9-Calendar-fullBookedMessage",
            styles["Calendar-fullBookedMessage"]
          )}>
          {errorMessage}
        </div>
      </div>
      {fullyBooked && !hideCalendar && (
        <div
          className={classnames(
            "wbkv9-Calendar-nextAvailableMessage",
            styles["Calendar-nextAvailableMessage"]
          )}>
          <FormattedMessage {...msgs.nextAvailable} />:{" "}
          <span
            className={classnames(
              "wbkv9-Calendar-nextAvailableDate",
              styles["Calendar-nextAvailableDate"]
            )}
            onClick={handleFullyBooked}>
            {nextAvailable}
          </span>
        </div>
      )}
    </div>
  );
};

function renderRate(rate) {
  return (
    <div className={styles.rate}>
      <div>
        <FormattedNumber value={parseInt(rate, 10)} maximumFractionDigits={0} />
      </div>
      <div className={styles.decimals}>{getRateDecimalsNoRounding(rate)}</div>
    </div>
  );
}

function renderPercentage(rate) {
  return (
    <span>
      {" "}
      -<FormattedNumber value={rate * 100} maximumFractionDigits={0} />%
    </span>
  );
}

function renderErrorMessage({ status, valueType, value, showDays, days }) {
  return (
    <BookableErrorMessage
      status={status}
      valueType={valueType}
      value={value}
      showDays={showDays}
      days={days}
      labelClassName={
        valueType !== constants.ARI_VALUE_TYPE.CALENDAR.UNAVAILABLE_FOR_WHOLE_RANGE &&
        styles.errorLabel
      }
    />
  );
}

const PricingInfo = ({
  totalRate,
  averageRate,
  discount,
  currency,
  errorMessage,
  rackRate,
  showDiscountsCalculation,
  hideCalendar,
  iframe,
}) => {
  if (errorMessage) {
    return null;
  }
  if (hideCalendar) {
    return <EmptyContainer />;
  }
  return (
    <div
      className={classnames(
        "wbkv9-Calendar-rateContainer",
        styles.rateContainer,
        styles["Calendar-rateWrapper"]
      )}>
      <ThreeLevelInfo
        firstLevel={<span>{currency}</span>}
        secondLevel={(totalRate && renderRate(totalRate)) || "-"}
        thirdLevel={
          (showDiscountsCalculation || iframe) &&
          rackRate && (
            <span>
              <span className={classnames(styles.strike)}>
                <FormattedNumber value={rackRate} minimumFractionDigits={2} />
              </span>
              {discount > 0 && discount && (
                <span className={classnames(styles.discount)}>{renderPercentage(discount)}</span>
              )}
            </span>
          )
        }
      />
      <ThreeLevelInfo
        firstLevel={
          <span>
            <span style={{ textTransform: "none" }} /> <FormattedMessage {...msgs.night} />
          </span>
        }
        secondLevel={(averageRate && renderRate(averageRate)) || "-"}
      />
    </div>
  );
};

const ConfirmButton = ({ handleSubmit, enabled, isRangeSet, startDate, endDate }) => {
  return (
    <div
      className={classnames(
        "wbkv9-Calendar-wbButtonContainer",
        styles.wbButtonContainer,
        !enabled && styles.disabled
      )}>
      <button onClick={handleSubmit} disabled={!enabled}>
        <div>
          {isRangeSet && (
            <span>
              {" "}
              <FormattedMessage {...msgs.confirmDates} />
            </span>
          )}
          {!isRangeSet && (
            <span>
              {" "}
              <FormattedMessage {...msgs.infoDisclaimer} />
            </span>
          )}
        </div>
        <div className={styles.mobileButtonDates}>
          {<FormattedDate day="2-digit" month="short" value={startDate} />} -{" "}
          {<FormattedDate day="2-digit" month="short" value={endDate} />}
        </div>
      </button>
    </div>
  );
};

function checkFullyBooked(calendarARI, from, limit) {
  const startDate = moment(from).startOf("month");
  const endDate = moment(from).add(limit, "months").endOf("month");
  for (const key in calendarARI) {
    if (calendarARI[key]) {
      const ariDate = moment(calendarARI[key].date);
      const isAvailable = calendarARI[key][constants.ARI_VALUE_TYPE.AVAILABILITY];
      const isAriDateInRange =
        ariDate.isSame(startDate) ||
        (ariDate.isAfter(startDate) && (ariDate.isBefore(endDate) || ariDate.isSame(endDate)));
      if (isAvailable && isAriDateInRange) {
        return null;
      }
      if (moment(calendarARI[key].date).isAfter(endDate, "month") && isAvailable) {
        return calendarARI[key].date;
      }
    }
  }
  return null;
}

function checkFullyBookedCombined(calendarARI, from) {
  const limits = { mobile: null, desktop: null };

  limits.mobile = checkFullyBooked(calendarARI, from, 0);
  limits.desktop = checkFullyBooked(calendarARI, from, 1);

  return limits;
}

/* TODO: UPDATE TO WORK WITH REACT-DAY-PICKER LATEST VERSION!! */
class Calendar extends Component {
  constructor(props) {
    super(props);

    this.isOutDay = this.isOutDay.bind(this);
    this.isInDay = this.isInDay.bind(this);
    this.isHoveredOutDay = this.isHoveredOutDay.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.isAvailable = this.isAvailable.bind(this);
    this.isRestricted = this.isRestricted.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.calculateNumberOfGuests = this.calculateNumberOfGuests.bind(this);
    this.renderDay = this.renderDay.bind(this);
    this.getBookedDailyPrices = this.getBookedDailyPrices.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getBookedDays = this.getBookedDays.bind(this);
    this.handleFullyBookedClick = this.handleFullyBookedClick.bind(this);
    this.state = {
      startMonth: moment(props.initialStartDate).startOf("month"),
      endMonth: moment(props.initialStartDate).add(1, "M").endOf("month"),
      dateToAdvance: {},
      showFullyBookedMobile: null,
      showFullyBookedDesktop: null,
      fullyBookedMessageClicked: false,
      ranges: [],
      allowChangeCheckoutOnce: false,
      allowChangeCheckinOnce: true,
      isCheckinRange: true,
    };
  }

  componentDidMount() {
    this.props.requestCalendarARI({
      propertyTicker: this.props.propertyTicker,
      inventoryTicker: this.props.inventoryTicker,
    });
    this.props.initialFullCalendarAriLoad({
      from: this.props.initialStartDate,
      to: this.props.initialEndDate,
      propertyTicker: this.props.propertyTicker,
    });
    if (this.props.iframe) {
      this.props.requestFullARIForSelectedCalendarDates({
        propertyTicker: this.props.propertyTicker,
        callingTicker: this.props.propertyTicker,
        newConfiguration: {
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().add(1, "days").format("YYYY-MM-DD"),
          il_equal: this.props.iframe && this.props.inventoryTicker,
          ignoredConfiguration: this.props.iframe && true,
        },
      });
    }
  }

  componentWillUnmount() {
    this.props.changeConfiguration({
      propertyTicker: this.props.propertyTicker,
      configuration: fromJS({ showCalendarByUrl: false }),
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.initialStartDate !== prevProps.initialStartDate ||
      this.props.initialEndDate !== prevProps.initialEndDate
    ) {
      this.props.requestCalendarARI({
        propertyTicker: this.props.propertyTicker,
        inventoryTicker: this.props.inventoryTicker,
      });
      this.props.initialFullCalendarAriLoad({
        from: this.props.initialStartDate,
        to: this.props.initialEndDate,
        propertyTicker: this.props.propertyTicker,
      });
    }
    if (
      !this.state.fullyBookedMessageClicked &&
      (prevProps.calendarARI !== this.props.calendarARI || prevProps.from !== this.props.from)
    ) {
      const firstOutsideView = checkFullyBookedCombined(this.props.calendarARI, this.props.from);

      this.setState({
        showFullyBookedMobile: firstOutsideView.mobile,
        showFullyBookedDesktop: firstOutsideView.desktop,
      });
    }
  }

  getFormattedDay(day) {
    return getCalendarKey(day);
  }

  getBookedDailyPrices() {
    let dailyPrices = [];
    if (this.props.from && this.props.to) {
      const dateIterator = moment(this.props.from);
      while (dateIterator.toDate() < this.props.to) {
        const formatted = this.getFormattedDay(dateIterator.toDate());
        if (this.props.prices[formatted]) {
          dailyPrices.push(this.props.prices[formatted]);
        } else {
          dailyPrices = [];
          break;
        }
        dateIterator.add(1, "day");
      }
    }
    return dailyPrices.length > 0 ? dailyPrices : null;
  }

  getBookedDays() {
    const bookedDays = [];
    if (this.props.from && this.props.to) {
      const dateIterator = moment(this.props.from);
      while (dateIterator.toDate() < this.props.to) {
        const formatted = this.getFormattedDay(dateIterator.toDate());
        if (!this.props.prices[formatted]) {
          bookedDays.push(new Date(dateIterator.toDate()));
        }
        dateIterator.add(1, "day");
      }
    }

    const { intl } = this.props;
    return bookedDays
      .reduce((acc, day) => {
        const days = acc.pop() || [];
        const [firstDay] = days;
        if (!firstDay) {
          return [...acc, [day]];
        }

        if (firstDay.getMonth() !== day.getMonth()) {
          return [...acc, [...days], [day]];
        }

        return [...acc, [...days, day]];
      }, [])
      .reduce((daysString, monthDays) => {
        const days = monthDays.map(day => day.getDate()).join(",");
        const [firstDate] = monthDays;
        const month = intl.formatDate(firstDate, {
          month: "short",
        });
        return `${!daysString ? daysString : `${daysString} /`} ${days} ${month.toUpperCase()}`;
      }, "");
  }

  getStatus(day, filterResult, statusDetail, isRangeSet, isUnavailableForWholeRange) {
    const key = this.getFormattedDay(day);
    if (isRangeSet && DateUtils.isDayInRange(day, this.props)) {
      const status = statusDetail && statusDetail.get("code");
      if (isUnavailableForWholeRange) {
        return constants.BOOKABLE_STATUS.RESTRICTED;
      }
      if (statusDetail && status) {
        if (status === constants.BOOKABLE_STATUS.RESTRICTED) {
          return status;
        }
        return this.props.prices.hasOwnProperty(key)
          ? constants.BOOKABLE_STATUS.AVAILABLE
          : constants.BOOKABLE_STATUS.UNAVAILABLE;
      }
    }
    if (filterResult === null) {
      return this.props.prices.hasOwnProperty(key)
        ? constants.BOOKABLE_STATUS.AVAILABLE
        : constants.BOOKABLE_STATUS.UNAVAILABLE;
    }

    if (filterResult.finalError === null) {
      return this.props.prices.hasOwnProperty(key)
        ? constants.BOOKABLE_STATUS.AVAILABLE
        : constants.BOOKABLE_STATUS.UNAVAILABLE;
    }
    if (DateUtils.isDayInRange(day, this.props)) {
      if (filterResult.status === constants.BOOKABLE_STATUS.RESTRICTED) {
        return constants.BOOKABLE_STATUS.RESTRICTED;
      }
    }
    return this.props.prices.hasOwnProperty(key)
      ? constants.BOOKABLE_STATUS.AVAILABLE
      : constants.BOOKABLE_STATUS.UNAVAILABLE;
  }

  calculateNumberOfGuests() {
    if (this.props.iframe) {
      return this.props.numberOfGuests;
    }
    const isEstablishmentCalendar =
      typeof this.props.inventoryTicker === "undefined" || this.props.inventoryTicker === null;
    if (isEstablishmentCalendar) {
      if (constants.OCCUPANT_RESTRICTION.NONE === this.props.occupantRestriction) {
        return false; // because we have no values for the booking form occupation we do not display anything, case bed and toc_hostels
      }
      return this.props.numberOfGuests; // // this solves the problem when the filter is 1 occupant on the booking form on the hotel calendar
    }
    return this.props.inventoryNumberOfGuests; // on the inventory calendar the occupation is ALWAYS the one of the inventory
  }

  handleResetClick(event) {
    event.preventDefault();
    this.props.setDate({
      propertyTicker: this.props.propertyTicker,
      from: null,
      to: null,
    });
  }

  handleMonthChange(month) {
    this.setState({
      startMonth: moment(month).startOf("month"),
      endMonth: moment(month).add(1, "M").endOf("month"),
      isAvailableForOtherOccupations: false,
    });
  }

  handleDayClick(day) {
    let resetRanges = false;
    let sendRequestAri = false;
    let range = {};
    let allowChangeCheckoutOnce = false;
    let allowChangeCheckinOnce = true;
    let isCheckinRange = true;
    /* Disabling interaction with previous days from today */
    if (moment(day).startOf("day") < moment().startOf("day")) {
      return;
    }
    /* Disabling double clicking a day  */
    if (this.props.from && this.props.from.getTime() === day.getTime()) {
      return;
    }
    if (this.props.from && !this.props.to) {
      resetRanges = true;
    }
    if (!this.props.from || !this.props.to) {
      if (moment(day) < moment(this.props.from)) {
        this.props.setDate({
          to: null,
          from: day,
          propertyTicker: this.props.propertyTicker,
        });
      } else {
        range = DateUtils.addDayToRange(day, this.props);
        this.props.setDate({
          to: range.to,
          from: range.from,
          propertyTicker: this.props.propertyTicker,
        });
        sendRequestAri = true;
      }
    } else {
      if (moment(day) > moment(this.props.from) && moment(day) < moment(this.props.to)) {
        allowChangeCheckinOnce = true;
        allowChangeCheckoutOnce = true;
        if (this.state.isCheckinRange) {
          range = {
            from: day,
            to: this.props.to,
          };
          isCheckinRange = false;
        } else {
          range = {
            from: this.props.from,
            to: day,
          };
          isCheckinRange = true;
          allowChangeCheckoutOnce = false;
        }
        this.props.setDate({
          ...range,
          propertyTicker: this.props.propertyTicker,
        });
        sendRequestAri = true;
      } else if (moment(day) < moment(this.props.from)) {
        if (this.state.allowChangeCheckinOnce) {
          range = {
            from: day,
            to: this.props.to,
          };
          this.props.setDate({
            ...range,
            propertyTicker: this.props.propertyTicker,
          });
          sendRequestAri = true;
          allowChangeCheckinOnce = false;
          isCheckinRange = false;
        } else {
          this.props.setDate({
            to: null,
            from: day,
            propertyTicker: this.props.propertyTicker,
          });
        }
      } else if (moment(day) > moment(this.props.to)) {
        if (this.state.allowChangeCheckoutOnce) {
          range = {
            from: this.props.from,
            to: day,
          };
          this.props.setDate({
            ...range,
            propertyTicker: this.props.propertyTicker,
          });
          sendRequestAri = true;
        } else {
          this.props.setDate({
            to: null,
            from: day,
            propertyTicker: this.props.propertyTicker,
          });
        }
      } else {
        resetRanges = true;
        this.props.setDate({
          propertyTicker: this.props.propertyTicker,
          from: day,
          to: null,
        });
      }
    }
    if (resetRanges) {
      this.setState({
        ranges: [],
      });
    }
    if (sendRequestAri) {
      // initiate ARI query
      this.props.requestFullARIForSelectedCalendarDates({
        propertyTicker: this.props.propertyTicker,
        callingTicker: this.props.propertyTicker,
        newConfiguration: {
          startDate: range.from,
          endDate: range.to,
          il_equal: this.props.iframe && this.props.inventoryTicker,
          ignoredConfiguration: this.props.iframe && true,
        },
      });
    }
    if (allowChangeCheckoutOnce !== this.state.allowChangeCheckoutOnce) {
      this.setState({
        allowChangeCheckoutOnce,
      });
    }
    if (allowChangeCheckinOnce !== this.state.allowChangeCheckinOnce) {
      this.setState({
        allowChangeCheckinOnce,
      });
    }
    if (isCheckinRange !== this.state.isCheckinRange) {
      this.setState({
        isCheckinRange,
      });
    }
  }

  handleSubmit() {
    if (this.props.iframe) {
      window?.parent?.postMessage(
        JSON.stringify({
          startDate: this.props.from,
          endDate: this.props.to,
          accommoddationName: this.props.inventoryDetails?.accommoddationName,
          defaultPrimaryText: this.props.inventoryDetails?.defaultPrimaryText,
          mealPlanName: this.props.inventoryDetails?.mealPlanName,
          conditionName: this.props.inventoryDetails?.conditionName,
          totalRate: this.props.mainAriValueWithExchange?.totalRate,
          averageRate: this.props.mainAriValueWithExchange?.averageRate,
          currency: this.props.mainAriValueWithExchange?.currency,
          averageRackRate: this.props.mainAriValueWithExchange?.averageRackRate,
          rackRate: this.props.mainAriValueWithExchange?.rackRate,
        }),
        "*"
      );
    } else if (this.props.from && this.props.to) {
      const startDate = this.props.from;
      const endDate = this.props.to;
      this.props.onSubmit({
        startDate,
        endDate,
      });
      this.props.bookingFormChanged({
        startDate,
        endDate,
      });
    }
  }

  isAvailable(day) {
    return !!this.props.prices[this.getFormattedDay(day)];
  }

  isRestricted(day, filterResult) {
    const key = this.getFormattedDay(day);
    if (filterResult === null || !this.props.prices[key]) {
      return false;
    }
    if (this.props.from && this.props.to && this.props.calendarARI) {
      if (filterResult.finalError === null) {
        return false;
      }
      const dayDate = moment(day).startOf("day").toDate();
      const start = moment(this.props.from).startOf("day").toDate();
      const end = moment(this.props.to).startOf("day").toDate();
      if (dayDate >= start && dayDate <= end) {
        if (filterResult.status === constants.BOOKABLE_STATUS.RESTRICTED) {
          return true;
        }
      }
    }
    return false;
  }

  isOutDay(day) {
    if (this.props.to) {
      return this.getFormattedDay(this.props.to) === this.getFormattedDay(day);
    }
    return false;
  }

  isInDay(day) {
    return this.props.from && this.getFormattedDay(this.props.from) === this.getFormattedDay(day);
  }

  isHoveredOutDay(day) {
    const ranges = this.state.ranges || [];
    const lastRangeDay = (ranges.length && ranges[ranges.length - 1]) || undefined;
    if (lastRangeDay) {
      return this.getFormattedDay(lastRangeDay) === this.getFormattedDay(day);
    }
    return false;
  }

  completeRange(startDate, endDate) {
    const ranges = [];
    let date = moment(startDate);
    endDate = moment(endDate);

    while (date < endDate) {
      date = moment(date).add(1, "days");
      ranges.push(date.toDate());
    }
    return ranges;
  }

  handleMouseEnter(day) {
    let ranges = [];
    if (this.props.from && !this.props.to) {
      const startDate = this.getFormattedDay(this.props.from);
      const endDate = this.getFormattedDay(day);
      if (moment(endDate) > moment(startDate)) {
        ranges = [...this.completeRange(startDate, endDate)];
      }
      this.setState({
        ranges,
      });
    }
  }

  handleFullyBookedClick(month) {
    this.setState({
      dateToAdvance:
        month === "mobile" ? this.state.showFullyBookedMobile : this.state.showFullyBookedDesktop,
      fullyBookedMessageClicked: true,
    });
  }

  /* TODO: change € to currency sign */
  renderDay(day, currencySymbol, priceCalendar, selected, isPropertyCalendar, hideCalendar) {
    const isHoveredOutDay = this.isHoveredOutDay(day);
    const isSelected = DateUtils.isDayInRange(day, this.props);
    const isOutDay = this.isOutDay(day);
    const formattedDay = this.getFormattedDay(day);
    const dayARI =
      this.props.calendarARI &&
      this.props.calendarARI.hasOwnProperty(formattedDay) &&
      this.props.calendarARI[formattedDay];
    let price =
      this.props.prices &&
      this.props.prices.hasOwnProperty(formattedDay) &&
      this.props.prices[formattedDay];
    if (isPropertyCalendar && price) {
      price = price * 2;
    }
    const availability = dayARI && dayARI[constants.ARI_VALUE_TYPE.AVAILABILITY];
    let rateMsg = price && (
      <span>
        {currencySymbol} {price.toFixed(0)}
      </span>
    );
    let showAlert = false;
    if (day >= this.state.startMonth && day <= this.state.endMonth && isPropertyCalendar) {
      if (availability && !price) {
        if (!this.state.isAvailableForOtherOccupations) {
          this.setState({ isAvailableForOtherOccupations: true });
        }
        showAlert = true;
        rateMsg = <span>(*)</span>;
      }
    }

    let showPrice = priceCalendar !== constants.PRICE_CALENDAR.HIDE_ALL_PRICES && selected;
    if (priceCalendar === constants.PRICE_CALENDAR.SHOW_SELECTED_DATE_PRICES) {
      showPrice = showPrice && selected;
    }
    // ---------- Normal Case ----------------
    // if out day shows arrow
    // if selected show moon
    // if show alert show asterisk
    // else shows price
    // --------- Hides all Prices ------------
    // if out day shows arrow
    // if selected show moon
    // if show alert show nothing
    // else shows nothing
    // --------- Shows only selected Prices ------------
    // if out day shows arrow
    // if selected show price
    // if show alert show nothing
    // else shows nothing
    let dayRender = null;
    if (isHoveredOutDay) {
      dayRender = (
        <span>
          <div className={styles.relativeWrapper}>
            <div className={classnames(styles.arrow)}>
              <ExitToAppIcon />
            </div>
          </div>
        </span>
      );
    } else if (priceCalendar !== constants.PRICE_CALENDAR.HIDE_ALL_PRICES && isOutDay) {
      if (!hideCalendar) {
        dayRender = (
          <span>
            <div className={styles.relativeWrapper}>
              <div className={classnames(styles.arrow)}>
                <ExitToAppIcon />
              </div>
            </div>
            <div className={styles.dayPrice}> {rateMsg} </div>{" "}
          </span>
        );
      } else {
        dayRender = (
          <span>
            <div className={styles.relativeWrapper}>
              <div className={classnames(styles.arrow)}>
                <ExitToAppIcon />
              </div>
            </div>
            <div className={styles.dayPrice}></div>{" "}
          </span>
        );
      }
    } else if (showAlert) {
      switch (priceCalendar) {
        case constants.PRICE_CALENDAR.HIDE_ALL_PRICES:
          dayRender = null;
          break;
        case constants.PRICE_CALENDAR.SHOW_SELECTED_DATE_PRICES:
          if (selected) {
            dayRender = (
              <span>
                <div className={styles.dayPrice}>{rateMsg}</div>
              </span>
            );
          } else {
            dayRender = null;
          }
          break;
        case constants.PRICE_CALENDAR.SHOW_ALL_PRICES:
        default:
          if (!hideCalendar) {
            dayRender = (
              <span>
                <div className={styles.dayPrice}>{rateMsg}</div>
              </span>
            );
          }
      }
    } else if (
      priceCalendar !== constants.PRICE_CALENDAR.HIDE_ALL_PRICES &&
      isSelected &&
      this.props.to
    ) {
      if (!hideCalendar) {
        dayRender = (
          <span>
            <div className={styles.relativeWrapper}>
              <div className={classnames(styles.dayPriceNightIcon)}>
                <NightIcon />
              </div>
            </div>
            <div className={styles.dayPrice}>{rateMsg} </div>{" "}
          </span>
        );
      } else {
        dayRender = (
          <span>
            <div className={styles.relativeWrapper}>
              <div className={classnames(styles.dayPriceNightIcon)}>
                <NightIcon />
              </div>
            </div>
          </span>
        );
      }
    } else {
      switch (priceCalendar) {
        case constants.PRICE_CALENDAR.SHOW_SELECTED_DATE_PRICES:
        case constants.PRICE_CALENDAR.HIDE_ALL_PRICES:
          dayRender = null;
          break;
        case constants.PRICE_CALENDAR.SHOW_ALL_PRICES:
        default:
          if (!hideCalendar) {
            dayRender = (
              <span>
                <div className={classnames(styles.dayPrice)}>{rateMsg}</div>
              </span>
            );
          }
      }
    }
    return (
      <div className={classnames(styles.dayContainer)}>
        <div className={classnames(styles.day)}>{day.getDate()}</div>
        {dayRender}
      </div>
    );
  }

  render() {
    const {
      prices,
      loading,
      loaded,
      error,
      currency,
      property,
      priceCalendar,
      mainAriValueWithExchange,
      fullCalendarARILoading,
      showDiscountsCalculation,
      size,
      accommoddationName,
      defaultPrimaryText,
      mealplan,
      conditionName,
      inventoryDetails,
      iframe,
    } = this.props;
    const isPropertyCalendar = !!property;
    const {
      totalRate,
      averageRate,
      discountPercentage,
      statusDetail,
      averageRackRate,
      rackRate,
    } = mainAriValueWithExchange;
    const isRangeSet = this.props.from && this.props.to;
    const hideCalendar = this.props.session && this.props.session.hideCalendar;

    if (loading || !loaded || !prices) {
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    }
    if (error) {
      return (
        <div className={styles.loaderContainer}>
          <FormattedMessage {...msgs.errorOcurred} />
        </div>
      );
    }
    let filterResult = null;
    let errorMessage = null;
    let status = statusDetail && statusDetail.get("code");
    const buttonEnabled = isRangeSet && status && status === constants.BOOKABLE_STATUS.AVAILABLE;
    if (statusDetail && status && status !== constants.BOOKABLE_STATUS.AVAILABLE) {
      const bookedDays = this.getBookedDays();
      const valueType = statusDetail && statusDetail.get("filterType");
      const value = statusDetail && statusDetail.get("value");
      errorMessage = renderErrorMessage({
        status,
        valueType,
        value,
        showDays: true,
        days: bookedDays,
      });
    }
    if (this.props.from && this.props.to && this.props.calendarARI) {
      filterResult = filter(
        this.props.from,
        this.props.to,
        this.props.calendarARI,
        isPropertyCalendar
      );
    }

    const isUnavailableForWholeRange =
      isRangeSet &&
      status === constants.BOOKABLE_STATUS.UNAVAILABLE &&
      filterResult &&
      filterResult.status === null;
    const modifiers = {
      selected: day => DateUtils.isDayInRange(day, this.props),
      isPastDay: DateUtils.isPastDay,
      isAvailable: day =>
        this.getStatus(day, filterResult, statusDetail, isRangeSet, isUnavailableForWholeRange) ===
        constants.BOOKABLE_STATUS.AVAILABLE,
      isUnavailable: day =>
        this.getStatus(day, filterResult, statusDetail, isRangeSet, isUnavailableForWholeRange) ===
        constants.BOOKABLE_STATUS.UNAVAILABLE,
      isRestricted: day =>
        this.getStatus(day, filterResult, statusDetail, isRangeSet, isUnavailableForWholeRange) ===
        constants.BOOKABLE_STATUS.RESTRICTED,
      isOutDay: this.isOutDay,
      isInDay: this.isInDay,
      showRange: this.state.ranges,
      isHoveredOutDay: this.isHoveredOutDay,
    };

    const currencySymbol = getSymbolFromCurrency(
      iframe ? this.props.mainAriValueWithExchange.currency : this.props.currency
    );
    if (isUnavailableForWholeRange) {
      errorMessage = renderErrorMessage({
        status: constants.BOOKABLE_STATUS.RESTRICTED,
        valueType: constants.ARI_VALUE_TYPE.CALENDAR.UNAVAILABLE_FOR_WHOLE_RANGE,
        value: 0,
        showDays: false,
        days: [],
      });
      status = constants.BOOKABLE_STATUS.RESTRICTED;
    }
    const { isAvailableForOtherOccupations } = this.state;

    const mealPlanName =
      !iframe && (!mealplan || typeof mealplan === "string" ? mealplan : mealplan.get("name"));
    const numberOfGuests = this.calculateNumberOfGuests();
    return (
      <div
        className={classnames(
          "wbkv9-CalendarContainer",
          styles.calendarContainer,
          size === "SMALL" && styles.small
        )}>
        {fullCalendarARILoading && (
          <div className={styles.loaderContainer}>
            <Loader />
          </div>
        )}
        <div
          className={classnames(
            "wbkv9-Calendar",
            "RangeExample",
            styles.Calendar,
            fullCalendarARILoading && styles.hidden
          )}>
          <div className={classnames(styles["Calendar-headerCloseWrapper"])}>
            {!iframe && (
              <div
                className={classnames(styles["Calendar-closeButton"])}
                onClick={this.props.handleCloseModal}>
                <CerrarIcon />
              </div>
            )}
            <div className={classnames(styles["Calendar-headerWrapper"])}>
              <div className={classnames(styles["Calendar-header"])}>
                {iframe
                  ? inventoryDetails?.accommoddationName
                  : isPropertyCalendar
                  ? property.get("name")
                  : accommoddationName}
              </div>
              {!isPropertyCalendar && (
                <div className={classnames(styles["Calendar-subHeader"])}>
                  {" "}
                  {iframe ? inventoryDetails?.defaultPrimaryText : defaultPrimaryText}
                  {" · "}
                  {iframe ? inventoryDetails?.mealPlanName : mealPlanName}
                  {" · "}
                  {iframe ? inventoryDetails?.conditionName : conditionName}{" "}
                </div>
              )}
            </div>
          </div>
          {!this.state.fullyBookedMessageClicked && this.state.showFullyBookedMobile && (
            <div
              className={classnames(
                "wbkv9-NextAvailableButtonContainer",
                styles["Calendar-nextAvailableButtonContainer-mobile"]
              )}>
              <button
                onClick={() => {
                  this.handleFullyBookedClick("mobile");
                }}
                className={classnames(
                  "wbkv9-NextAvailableButton",
                  styles["Calendar-nextAvailableButton"]
                )}>
                <FormattedMessage {...msgs.goNextAvailable} />
              </button>
            </div>
          )}
          {!this.state.fullyBookedMessageClicked && this.state.showFullyBookedDesktop && (
            <div
              className={classnames(
                "wbkv9-NextAvailableButtonContainer",
                styles["Calendar-nextAvailableButtonContainer-desktop"]
              )}>
              <button
                onClick={() => {
                  this.handleFullyBookedClick("desktop");
                }}
                className={classnames(
                  "wbkv9-NextAvailableButton",
                  styles["Calendar-nextAvailableButton"]
                )}>
                <FormattedMessage {...msgs.goNextAvailable} />
              </button>
            </div>
          )}
          <div>
            <div>
              <DayPicker
                numberOfMonths={2}
                modifiers={modifiers}
                renderDay={day =>
                  this.renderDay(
                    day,
                    currencySymbol,
                    priceCalendar,
                    modifiers.selected(day),
                    isPropertyCalendar,
                    hideCalendar
                  )
                }
                onDayClick={this.handleDayClick}
                property={property}
                from={this.props.from}
                to={this.props.to}
                onMonthChange={this.handleMonthChange}
                advanceMonth={this.state.dateToAdvance}
                fromMonth={new Date()}
                onDayMouseEnter={this.handleMouseEnter}
              />
              <Disclaimer
                property={property}
                isRangeSet={isRangeSet}
                isAvailableForOtherOccupations={isAvailableForOtherOccupations}
                isPropertyCalendar={isPropertyCalendar}
              />
            </div>
            <div className={styles.legendContainer}>
              <div className={classnames("wbkv9-Calendar-legend", styles["Calendar-legend"])}>
                <StayInfo {...this.props} numberOfGuests={numberOfGuests} />

                {status !== constants.BOOKABLE_STATUS.AVAILABLE && (
                  <StayInfo {...this.props} numberOfGuests={numberOfGuests} mobile />
                )}

                {(!isRangeSet || hideCalendar) && (
                  <div
                    className={classnames(
                      "wbkv9-Calendar-legendSection",
                      styles["Calendar-legendSection"]
                    )}
                  />
                )}

                {isRangeSet && (
                  <div
                    className={classnames(
                      `${!hideCalendar && "wbkv9-Calendar-legendSection"}`,
                      `${!hideCalendar && styles["Calendar-legendSection"]}`
                    )}>
                    {!hideCalendar && (
                      <>
                        <RestrictionMessage
                          className={classnames(
                            "wbkv9-Calendar-restrictionMessage",
                            styles["Calendar-restrictionMessage-mobile"]
                          )}
                          errorMessage={errorMessage}
                          status={status}
                          hideCalendar={hideCalendar}
                          isUnavailableForWholeRange={isUnavailableForWholeRange}
                          fullyBooked={
                            !this.state.fullyBookedMessageClicked &&
                            !!this.state.showFullyBookedMobile
                          }
                          handleFullyBooked={() => {
                            this.handleFullyBookedClick("mobile");
                          }}
                          nextAvailable={
                            <FormattedDate
                              day="2-digit"
                              month="short"
                              year="numeric"
                              value={this.state.showFullyBookedMobile}
                            />
                          }
                        />
                        <RestrictionMessage
                          className={classnames(
                            "wbkv9-Calendar-restrictionMessage",
                            styles["Calendar-restrictionMessage-desktop"]
                          )}
                          errorMessage={errorMessage}
                          status={status}
                          hideCalendar={hideCalendar}
                          isUnavailableForWholeRange={isUnavailableForWholeRange}
                          fullyBooked={
                            !this.state.fullyBookedMessageClicked &&
                            !!this.state.showFullyBookedDesktop
                          }
                          handleFullyBooked={() => {
                            this.handleFullyBookedClick("desktop");
                          }}
                          restrictions={
                            !this.state.fullyBookedMessageClicked &&
                            this.state.showFullyBookedDesktop
                          }
                          nextAvailable={
                            <FormattedDate
                              day="2-digit"
                              month="short"
                              year="numeric"
                              value={this.state.showFullyBookedDesktop}
                            />
                          }
                        />
                      </>
                    )}
                    <PricingInfo
                      totalRate={totalRate}
                      averageRate={averageRate}
                      currency={
                        iframe ? this.props.mainAriValueWithExchange.currency : this.props.currency
                      }
                      discount={discountPercentage}
                      errorMessage={errorMessage}
                      averageRackRate={averageRackRate}
                      rackRate={rackRate}
                      startDate={this.props.from}
                      endDate={this.props.to}
                      showDiscountsCalculation={showDiscountsCalculation}
                      numberOfGuests={numberOfGuests}
                      hideCalendar={hideCalendar}
                      iframe={this.props.iframe}
                    />
                  </div>
                )}

                <ConfirmButton
                  enabled={buttonEnabled}
                  handleSubmit={this.handleSubmit}
                  isRangeSet={isRangeSet}
                  startDate={this.props.from}
                  endDate={this.props.to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Calendar.propTypes = {
  prices: PropTypes.object,
  intl: PropTypes.object,
  initialStartDate: PropTypes.object,
  initialEndDate: PropTypes.object,
  currency: PropTypes.string,
  onSubmit: PropTypes.func,
  data: PropTypes.object,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  requestCalendarARI: PropTypes.func,
  propertyTicker: PropTypes.string,
  property: PropTypes.object,
  inventoryTicker: PropTypes.string,
  // cheapestBookable: PropTypes.string,
  calendarARI: PropTypes.object,
  priceCalendar: PropTypes.string,
  requestFullARIForSelectedCalendarDates: PropTypes.func,
  initialFullCalendarAriLoad: PropTypes.func,
  setDate: PropTypes.func,
  from: PropTypes.object,
  to: PropTypes.object,
  mainAriValue: PropTypes.object,
  numberOfGuests: PropTypes.number,
  inventoryNumberOfGuests: PropTypes.number,
  numberOfNights: PropTypes.number,
  occupantRestriction: PropTypes.string,
  fullCalendarARILoading: PropTypes.bool,
  showDiscountsCalculation: PropTypes.bool,
  size: PropTypes.string,
  accommoddationName: PropTypes.string,
  defaultPrimaryText: PropTypes.string,
  mealplan: PropTypes.string,
  conditionName: PropTypes.string,
  handleCloseModal: PropTypes.func,
  mainAriValueWithExchange: PropTypes.object,
};

export default connect(
  createStructuredSelector({
    prices: dataWithExchangeSelector,
    calendarARI: calendarARISelector,
    loading: loadingSelector,
    loaded: loadedSelector,
    error: errorSelector,
    from: startDateSelector,
    to: endDateSelector,
    mainAriValue: mainAriValueSelector,
    mainAriValueWithExchange: mainAriValueWithExchangeSelector,
    numberOfGuests: numberOfGuestsSelector,
    occupantRestriction: occupantRestrictionSelector,
    numberOfNights: numberOfNightsSelector,
    fullCalendarARILoading: fullCalendarARILoadingSelector,
    inventoryDetails: inventoryDetailsSelector,
  }),
  dispatch => bindActionCreators({ ...actions, ...appActions, ...bookingFormActions }, dispatch)
)(injectIntl(withSessionData(Calendar)));
